var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockPermission = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 82,
    viewBox: "0 0 70 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 23,
    width: 68,
    height: 58,
    rx: 9,
    stroke: "#D2DAE4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2327 60H24C24 56.2445 26.9989 53.2 30.6981 53.2C34.3974 53.2 37.3963 56.2445 37.3963 60H35.1635C35.1635 57.4963 33.1643 55.4667 30.6981 55.4667C28.2319 55.4667 26.2327 57.4963 26.2327 60ZM44.4226 56.2668L41.8617 53.6681L39.3019 56.2668L37.7233 54.6643L40.282 52.0667L37.7233 49.4679L39.3019 47.8654L41.8617 50.4641L44.4215 47.8654L46 49.4679L43.4402 52.0667L46 54.6654L44.4226 56.2668ZM30.6981 52.0667C28.2319 52.0667 26.2327 50.037 26.2327 47.5333C26.2327 45.0296 28.2319 43 30.6981 43C33.1643 43 35.1635 45.0296 35.1635 47.5333C35.1605 50.0357 33.163 52.0635 30.6981 52.0667ZM30.6981 45.2667C29.4784 45.2679 28.4854 46.2627 28.4679 47.5009C28.4504 48.739 29.415 49.7623 30.6341 49.799C31.8533 49.8357 32.8759 48.8724 32.9308 47.6353V48.0887V47.5333C32.9308 46.2815 31.9312 45.2667 30.6981 45.2667Z",
    fill: "#D2DAE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 22L53 14C53 6.8203 47.1797 1 40 0.999999L30 0.999999C22.8203 0.999999 17 6.8203 17 14L17 22",
    stroke: "#D2DAE4",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockPermission);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock-permission.5b83af08b088bd94b5593719f3611864.svg";